import { creatorbase } from '@round/api';
import { CREATORBASE_ROOT_PATH } from 'Modules/Navigation/whitelabel/routes';

type ReceivedCampaignFields = {
    run_by_partnership_id?: number | null;
};

// A campaign is received when another team runs it and shares it with this one
export function isReceivedCampaign<TCampaign extends ReceivedCampaignFields>(
    campaign: TCampaign
): campaign is TCampaign & { run_by_partnership_id: number } {
    return typeof campaign.run_by_partnership_id === 'number';
}

export const getCampaignLink = (campaign?: creatorbase.Campaign | null) => {
    if (!campaign) {
        return '';
    }

    return `/${CREATORBASE_ROOT_PATH}/projects/${campaign?.project_id}/?expanded=${campaign?.id}#${campaign?.platform}`;
};

const NON_BLOCKING_PAYMENT_STATUSES: ReadonlyArray<creatorbase.CampaignPaymentStatus> = ['CANCELLED', 'FAILED'];

export const isCampaignCostLockedByPayment = (
    paymentStatus: creatorbase.CampaignPaymentStatus | null | undefined
): boolean => !!paymentStatus && !NON_BLOCKING_PAYMENT_STATUSES.includes(paymentStatus);

// A received campaign has no currency_id, so its currency is the key its stats are served under
export const getReceivedCampaignCurrencyId = (amountsByCurrency: Record<number, number> | null | undefined) => {
    const currencyId = Object.keys(amountsByCurrency ?? {})[0];
    return currencyId === undefined ? undefined : Number(currencyId);
};
